import { render, staticRenderFns } from "./ClinicDoctorsIncomeReport.vue?vue&type=template&id=6d658f32&scoped=true"
import script from "./ClinicDoctorsIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorsIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d658f32",
  null
  
)

export default component.exports